import React, { useState, useEffect } from 'react';
import Header from './Layout/Header';
import AdminHeader from './Layout/AdminHeader';
import HomePage from './Component/HomePage';
import OurHistory from './Component/OurHistory';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import TeamsPage from './Component/TeamsPage';
import PrivatePolicy from './Component/PrivatePolicy';
import Healthcare from './Component/Healthcare';
import HigherEducation from './Component/HigherEducation';
import ExecPlacement from './Component/ExecPlacement';
import AiInnovation from './Component/AiInnovation';
import CampusSafety from './Component/CampusSafety';
import ExecCoaching from './Component/ExecCoaching';
import NewsTesting from './Component/NewsTesting';
import ContactUs from './Component/ContactUs';
import CurrentSearch from './Component/CurrentSearch';
import SiteMap from './Component/SiteMap';
import NotFound from './Component/NotFound';
import { profileRoutes } from './router/profileRoutes';
import { adminRoutes } from './router/adminRoutes';
import { newsAndInsightsRoutes } from './router/news&insightsRoutes';
import './App.css';
import Footer from './Layout/Footer';
import ScrollToTop from './ScrollToTop';

function App() {
  const [isAdminLoggedIn, setIsAdminLoggedIn] = useState(false);

  useEffect(() => {
    // Check if admin is logged in by checking for adminToken
    const checkAdminAuth = () => {
      const token = localStorage.getItem('adminToken') || sessionStorage.getItem('adminToken');
      setIsAdminLoggedIn(!!token);
    };

    checkAdminAuth();

    // Listen for storage changes (e.g., when token is removed on logout)
    const handleStorageChange = () => {
      checkAdminAuth();
    };

    window.addEventListener('storage', handleStorageChange);
    
    // Also check periodically in case token is removed in same window
    const interval = setInterval(checkAdminAuth, 1000);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      clearInterval(interval);
    };
  }, []);

  return (
    <div className="App">
      <Router>
        <ScrollToTop />
        {isAdminLoggedIn ? <AdminHeader /> : <Header />}        
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/teams" element={<TeamsPage />} />
          <Route path="/privacy-policy" element={<PrivatePolicy />} />
          <Route path="/our-history" element={<OurHistory />} />
          <Route path="/healthcare" element={<Healthcare />} />
          <Route path="/higher-education" element={<HigherEducation />} />
          <Route path="/services/executive-search" element={<ExecPlacement />} />
          <Route path="/services/ai-innovation" element={<AiInnovation />} />
          <Route path="/services/campus-safety" element={<CampusSafety />} />
          <Route path="/services/executive-coaching" element={<ExecCoaching />} />
          <Route path="/news-testing" element={<NewsTesting />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/current-searches" element={<CurrentSearch />} />
          <Route path="/sitemap" element={<SiteMap />} />
          {newsAndInsightsRoutes}
          {profileRoutes}
          {adminRoutes}
          <Route path="/404" element={<NotFound />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
